export const newCustomer = {
  event: null,
  category: 'Revenue',
  action: 'click',
  label: 'New Customer',
  noninteraction: true,
};

export const newCard = {
  event: null,
  category: 'Revenue',
  action: 'click',
  label: 'Add Credit Card',
  noninteraction: true,
};

export const changePlan = {
  event: null,
  category: 'Revenue',
  action: 'click',
  label: 'Change Plan',
  noninteraction: true,
};

export const cancelPlan = {
  event: null,
  category: 'Revenue',
  action: 'click',
  label: 'Cancel Subscription',
  noninteraction: true,
};

export const pausePlan = {
  event: null,
  category: 'Revenue',
  action: 'click',
  label: 'Pause Subscription',
  noninteraction: true,
};

export const newUser = {
  event: null,
  category: 'Revenue',
  action: 'click',
  label: 'New Customer',
  noninteraction: true,
};

export const editDesign = {
  event: null,
  category: 'Engagement',
  action: 'click',
  label: 'Edit Design',
  noninteraction: true,
};

export const saveDesign = {
  event: null,
  category: 'Engagement',
  action: 'click',
  label: 'Save Design',
  noninteraction: true,
};

export const createVideo = {
  event: null,
  category: 'Engagement',
  action: 'click',
  label: 'Generate Video',
  noninteraction: true,
};

export const addSubtitles = {
  event: null,
  category: 'Engagement',
  action: 'click',
  label: 'Create Subtitles',
  noninteraction: true,
};

export const createCaptionedVideo = {
  event: null,
  category: 'Engagement',
  action: 'click',
  label: 'Create Subtitled Video',
  noninteraction: true,
};

export const createWavveLink = {
  event: null,
  category: 'Engagement',
  action: 'click',
  label: 'Create Wavve.link',
  noninteraction: true,
};
